import { create } from 'zustand';
import { axiosEnquiryInstance, axiosInstance } from '../lib/axiosInstance';
import { toast } from 'react-hot-toast';
import useAuthStore from './useAuthStore';

const useSupportStore = create((set, get) => ({
    tickets: [],
    isLoading: false,
    isSubmitting: false,
    error: null,

    createTicket: async (ticketData) => {
        set({ isSubmitting: true, error: null });
        const { token, user, userType } = useAuthStore.getState();

        // Augment data based on authentication status
        if (token && user) {
            ticketData.priority = 'High';
            if (userType === 'builder') {
                ticketData.user_type = 'Registered Builder';
                ticketData.user_reference_id = user.builderUniqueId || user.id;
            } else if (userType === 'customer') {
                ticketData.user_type = 'Registered Customer';
                ticketData.user_reference_id = user.customerId;
            }
        } else {
            ticketData.priority = 'Low';
            ticketData.user_type = 'Not Registered';
        }

        try {
            const response = await axiosEnquiryInstance.post('/tickets', ticketData);
            if (response.data.success) {
                toast.success('Support ticket created successfully!');
                // If user is logged in, refresh their ticket list
                if (token) {
                    get().fetchMyTickets();
                }
                return { success: true };
            } else {
                throw new Error(response.data.message || 'Failed to create ticket.');
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'An error occurred while creating the ticket.';
            toast.error(errorMsg);
            set({ error: errorMsg });
            return { success: false, message: errorMsg };
        } finally {
            set({ isSubmitting: false });
        }
    },

    fetchMyTickets: async () => {
        set({ isLoading: true, error: null });
        const { token } = useAuthStore.getState();
        if (!token) {
            set({ isLoading: false, tickets: [] }); // No tickets for logged-out users
            return;
        }

        try {
            // Use axiosInstance (port 5000) instead of axiosInstancev2 (port 3001)
            // This avoids JWT_SECRET mismatch issues between backends
            const response = await axiosInstance.get('/tickets/my-tickets', {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (response.data.success) {
                set({ tickets: response.data.tickets || [], isLoading: false });
            } else {
                throw new Error(response.data.message || 'Failed to fetch tickets.');
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message || 'An error occurred while fetching your tickets.';
            toast.error(errorMsg);
            set({ error: errorMsg, tickets: [], isLoading: false });
        }
    },
}));

export default useSupportStore;